var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tabs',{attrs:{"name":"tabsComprehensiveEvaluation"},on:{"on-click":_vm.handleClickTab}},_vm._l((_vm.tabs),function(item){return _c('TabPane',{key:item.name,attrs:{"label":item.label,"name":item.name,"tab":"tabsComprehensiveEvaluation"}},[(_vm.currentTab==item.name)?_c(item.component,{key:item.name,tag:"component"}):_vm._e()],1)}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23b0daf8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/pdQualityControlManage/index.vue
// module id = null
// module chunks = 